export default __webpack_public_path__ + "assets/images/icon-resend.0b492bac226d68ecab9035296a227d01.svg";